import { differenceInYears, isValid, parse } from 'date-fns';
import { DATE_MM_DD_YYYY } from 'shared/utils/string/date';
import { z } from 'zod';

const dateOfBirthValidationMessages = {
  required: 'Required',
  invalid: 'Enter a valid date of birth',
  ageMin: 'You must be at least 18 years old',
  ageMax: 'Enter a valid date of birth',
};

export const DOBVerificationSchema = z.object({
  dateOfBirth: z
    .string({ error: dateOfBirthValidationMessages.required })
    .min(1, { error: dateOfBirthValidationMessages.required })
    .regex(DATE_MM_DD_YYYY, { error: dateOfBirthValidationMessages.invalid })
    .transform((value) => parse(value, 'MM/dd/yyyy', new Date()))
    .refine((date) => isValid(date), {
      error: dateOfBirthValidationMessages.invalid,
    })
    .transform((date) => differenceInYears(new Date(), date))
    .pipe(
      z
        .number({ error: dateOfBirthValidationMessages.invalid })
        .min(18, { error: dateOfBirthValidationMessages.ageMin })
        .max(120, { error: dateOfBirthValidationMessages.ageMax }),
    ),
});
